import React from "react";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  padding: ${theme.spacing.unit * 2}px ${theme.spacing.unit * 1}px 0 0;
`;

const Text = styled.label`
  visibility: ${(props) => (props.$isHidden ? "hidden" : "visible")};

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 122%;
  color: ${theme.colors.gray4};

  span {
    font-weight: normal;
  }

  ${theme.media.phone`
    display: ${(props) => (props.$shouldHideOnMobile ? "none" : "block")};
  `}
`;

const MobileText = styled.label`
  display: none;

  font-family: Inter;
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.colors.gray4};

  span {
    font-weight: normal;
  }

  ${theme.media.phone`
    display: block;
  `}
`;

const Label = (props) => {
  const { className } = props;

  // Placeholder to take up space
  let text = "Placeholder Label";
  let isHidden = true;
  if (props.text) {
    text = props.text;
    isHidden = false;
  }
  // Obsolete, I think
  let shouldHideOnMobile = false;
  if (props.mobileText) {
    shouldHideOnMobile = true;
  }

  return (
    <Container className={className}>
      <Text $isHidden={isHidden} $shouldHideOnMobile={shouldHideOnMobile}>
        {text}
        {props.isOptional && <span> (Optional)</span>}
        {props.isRequired && " *"}
      </Text>
      {props.mobileText && (
        <MobileText>
          {props.mobileText}
          {props.isOptional && <span> (Optional)</span>}
          {props.isRequired && " *"}
        </MobileText>
      )}
    </Container>
  );
};

export default Label;
